import { render, staticRenderFns } from "./SalesByAdvisor.vue?vue&type=template&id=96a215ae&scoped=true&"
import script from "./SalesByAdvisor.vue?vue&type=script&lang=js&"
export * from "./SalesByAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./SalesByAdvisor.vue?vue&type=style&index=0&id=96a215ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a215ae",
  null
  
)

export default component.exports